import { REQUEST_STATUSES } from "@/constants/index.js";

import * as types from "./types.js";

const initialState = {
  univVideos: [],
  status: REQUEST_STATUSES.IDLE,
  err: null,
  noResults: false,
};

export const univVideosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_UNIV_VIDEOS: {
      const { univVideos, status, err } = action.payload;
      return {
        ...state,
        univVideos,
        status,
        err,
        noResults: !univVideos.length,
      };
    }
    case types.SET_UNIV_VIDEOS_REQUEST_STATUS:
      return { ...state, ...action.payload };
    case types.RESET_UNIV_VIDEOS:
      return { ...initialState };
    default:
      return state;
  }
};
